import {
  useIsDesktop,
  useIsMobile,
} from '@provider-portal/design-common/kalep/theme/hooks/useThemeHooks';

import { DeviceType } from '../api/openapi_gen/deliveryProviderPortal/deliveryProviderPortal/apis';

export function useDeviceType(): DeviceType {
  const isDesktop = useIsDesktop();
  const isMobile = useIsMobile();

  if (isDesktop) {
    return DeviceType.DESKTOP;
  }

  if (isMobile) {
    return DeviceType.MOBILE;
  }

  return DeviceType.TABLET;
}
